import React from "react";

import s from "./HamburgerMenu.module.css";

export const HamburgerMenu = ({ open, onToggleMenu }: { open: boolean; onToggleMenu: () => void }) => {
	return (
		<div className={`${s.hamburger} ${open ? s.open_menu : ""}`} onClick={onToggleMenu}>
			<span className={s.hamburger_line} />
			<span className={s.hamburger_line} />
			<span className={s.hamburger_line} />
		</div>
	);
};
